import { Controller } from "@hotwired/stimulus"

// Logs a tap on an outbound affiliate link. The link keeps its real affiliate
// href, so the beacon never delays or reroutes the visit, and native apps still
// hand the URL to the system browser (or the retailer's app) as before.
export default class extends Controller {
  static values = { placement: String, vendorId: Number, productId: Number, entryPoint: String }

  track(event) {
    // auxclick also fires for right clicks, which only open a context menu
    if (event.type === "auxclick" && event.button !== 1) return

    const params = new URLSearchParams({ "affiliate_click[placement]": this.placementValue })
    if (this.hasVendorIdValue) params.append("affiliate_click[vendor_id]", this.vendorIdValue)
    if (this.hasProductIdValue) params.append("affiliate_click[product_id]", this.productIdValue)
    if (this.hasEntryPointValue) params.append("affiliate_click[entry_point]", this.entryPointValue)

    navigator.sendBeacon("/affiliate-clicks", params)
  }
}
